import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { USER } from "../graphql/queries";

export const useOrganization = (user) => {
  const [userOrganization, setUserOrganization] = useState({
    organization: {},
    showNewOrgForm: false,
    isAdding: false,
  });
  const [getUser] = useLazyQuery(USER, {
    onCompleted: async (data) => {
      if (data.users.length > 0 && data.users[0].organizations.length > 0) {
        setUserOrganization({
          ...userOrganization,
          organization: data.users[0].organizations[0],
        });
      }
    },
    onError: () => {
      // do nothing
    },
    fetchPolicy: "cache-only",
  });

  const addSelectedOrganization = (organization) => {
    setUserOrganization({
      ...userOrganization,
      isAdding: false,
      organization: organization,
    });
  };

  const setShowNewOrgForm = (value) => {
    setUserOrganization({
      ...userOrganization,
      showNewOrgForm: value,
    });
  };

  const updateIsAdding = (value) => {
    setUserOrganization({
      ...userOrganization,
      isAdding: value,
    });
  };

  useEffect(() => {
    getUser({
      variables: {
        where: {
          username: { equals: user.username },
        },
      },
    });
  }, [getUser, user.username]);

  return {
    userOrganization,
    setShowNewOrgForm,
    addSelectedOrganization,
    updateIsAdding,
  };
};
